import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Link from "gatsby-link";
import styled from "react-emotion";

import { colors, navbarHeight } from "../consts";
import { getSelectedIndicator, getCurrentDataKey } from "../utils";

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
`;
const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 30px;
  height: ${navbarHeight}px;
  width: 310px;
  background-color: ${colors.active};
  color: white;
  text-align: left;
  border: none;
  transition-duration: 0.2s;
  cursor: pointer;
  &:hover {
    background-color: #0099da;
  }
`;
const ButtonLabel = styled.span`
  flex-grow: 1;
`;
const ButtonLabelUpper = styled.span`
  font-weight: 600;
  color: #00223a;
  font-size: 12px;
`;
const DropdownIcon = styled.span`
  flex-grow: 0;
  transform-origin: center;
  transform: rotate(${props => (props.up ? "180deg" : "0deg")});
`;
const Dropdown = styled.div`
  position: absolute;
  z-index: 99;
  top: 100%;
  left: 0;
  right: 0;
  background-color: ${colors.primaryDark};
  padding: 20px 30px;
  text-align: left;
`;
const IndicatorLink = styled(({ isActive, ...props }) => <Link {...props} />)`
  display: block;
  transition-duration: 0.2s;
  margin: 8px 0;
  text-decoration: none;
  color: ${props => (props.isActive ? "white" : "#69CEF5")};
  &:hover {
    color: white;
  }
`;

class MapSelector extends React.PureComponent {
  static propTypes = {
    indicators: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        dataKey: PropTypes.string.isRequired
      })
    ).isRequired
  };

  state = { isOpen: false };
  ref = React.createRef();

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  render() {
    const selectedIndicator = getSelectedIndicator(
      this.props.location,
      this.props.indicators
    );
    const currentDataKey = getCurrentDataKey(this.props.location);
    return (
      <Wrapper innerRef={this.ref}>
        <Button onClick={this.toggle}>
          <ButtonLabel>
            {currentDataKey && selectedIndicator ? (
              <React.Fragment>
                <ButtonLabelUpper>Selected data point:</ButtonLabelUpper>
                <br />
                {selectedIndicator.title}
              </React.Fragment>
            ) : (
              "Select a data point"
            )}
          </ButtonLabel>
          <DropdownIcon up={this.state.isOpen}>
            <i className="icon-arrow-down icons" />
          </DropdownIcon>
        </Button>
        {this.state.isOpen && (
          <Dropdown>
            {this.props.indicators.map(indicator => (
              <IndicatorLink
                key={indicator.dataKey}
                isActive={indicator.dataKey === currentDataKey}
                to={`/map?key=${indicator.dataKey}`}
                onClick={this.close}
              >
                {indicator.title}
              </IndicatorLink>
            ))}
          </Dropdown>
        )}
      </Wrapper>
    );
  }

  handleClickOutside = e => {
    if (
      this.state.isOpen &&
      this.ref.current &&
      !this.ref.current.contains(e.target)
    ) {
      this.close();
    }
  };

  toggle = () => {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  };

  close = () => {
    this.setState({ isOpen: false });
  };
}

export default withRouter(MapSelector);

export const query = graphql`
  fragment MapSelector on MarkdownRemark {
    frontmatter {
      indicators {
        title
        dataKey
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/MapSelector.js